import {
  routeShowHeader,
  RouteHeaderConfig,
  RouteShowHeaderEntry
} from '../constants/keys.constant';
import {
  findRouteShowHeaderEntry as findRouteShowHeaderEntryFromLib,
  resolveRouteHeader as resolveRouteHeaderFromLib
} from '@esqyre/rental-lib';

export type { RouteHeaderConfig, RouteShowHeaderEntry };

export function findRouteShowHeaderEntry(url: string): RouteShowHeaderEntry | undefined {
  return findRouteShowHeaderEntryFromLib(url, routeShowHeader);
}

export function resolveRouteHeader(
  currentUrl: string,
  contextUrl?: string | null
): RouteHeaderConfig | null {
  return resolveRouteHeaderFromLib(currentUrl, routeShowHeader, contextUrl);
}
